import { Observable, BehaviorSubject, EMPTY, of } from 'rxjs';
import { switchMap, catchError, finalize, filter, take, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import * as _ from 'lodash';
import { UnAauthenticateApis } from './un-authenticate-api';
import { environment } from 'src/environments/environment';
// import { UnAauthenticateApis } from './un-authenticate-api';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  isRefreshingToken: boolean = false;
  tk: string = null;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  private refreshTokenSubject$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    /**
     * not authenticate api
     */

    if (request.url.includes(`${environment.baseUrl}/user/invite`)&&request.method=="GET") {
      // return next.handle(request);
      if (!request.url.includes(`${environment.baseUrl}/user/invite/list`)) {
        return next.handle(request);
      }
    }

    /**
     * - if user call authorized api or call from ca to redirect here
     * - ca will redirect here and confirm payment
     */
    if (_.indexOf(UnAauthenticateApis, request.url) !==-1 || (request.url.match('prestogateway') && this.router.url.includes('ca-confirm-payment'))) {
      return next.handle(request);
    }

    if (!request.url.includes('authenticate') && this.authService.getToken() == null) {
      return this.logoutUser(request, next);
    }

    /** Refresh */
    if (request.url.includes(this.authService.refreshTokenUrl)) {
      return next.handle(request);
    }
    /**
     * First login
     * Sequence is important
     */
    if (request.url.includes('authenticate')) {
      return next.handle(request);
    }

    /** Hanlde refresh */

    if (this.authService.isAuthenticated()) {
      this.tk = this.authService.getToken();
      if (this.isRefreshingToken) {
        return this.handleRefreshingInProgress(request, next);
      }

      // else check expiry
      if (this.authService.isExpiryTimeExceeded()) {
        return this.handleTokenExpiry(request, next);
      }
      // else apply auth token directly
      return next.handle(this.applyCredentials(request, this.tk));
    }

    // should not hit this case
    // will be redirected to login
    return next.handle(this.applyCredentials(request, this.tk));

  }

  private handleRefreshingInProgress(request, next): Observable<any> {
    /**
     * wait until refreshTokenSubject$ has a non-null value
     *  which means the new token is ready and we can retry the request again
     */
    return this.refreshTokenSubject$.pipe(
      filter((result) => result !== null),
      take(1),
      switchMap(() => next.handle(this.applyCredentials(request, this.tk))),
    );
  }

  private handleTokenExpiry(request, next) {
    // refreshing token
    this.isRefreshingToken = true;
    this.refreshTokenSubject$.next(null);
    return this.authService.refreshToken().pipe(
      switchMap((token) => {
        this.tk = token;
        this.refreshTokenSubject$.next(true);
        return next.handle(this.applyCredentials(request, this.tk));
      }),
      catchError((e) => {
        return of(e);
      }),
      finalize(() => (this.isRefreshingToken = false)),
    );
  }

  private applyCredentials(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  private logoutUser(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isRefreshingToken) {
      this.redirectToCurrentPage(req, next);
    } else {
      this.authService.clear();
      this.router.navigate(['/login']);
    }
    return EMPTY;
  }

  redirectToCurrentPage(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.applyCredentials(req, this.tokenSubject.getValue());
    return EMPTY;
  }

  unAutorizedUser(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.router.navigate(['ems/403-error']);
    return EMPTY;
  }
}
